import { styled } from '@mui/material';

export const MessageWrapper = styled('div')(() => ({
	position: 'relative',
	display: 'flex',
	flexDirection: 'column',
}));

export const MessageEditedAt = styled('div')<{ isMyMessage: boolean }>(
	({ theme, isMyMessage }) => ({
		position: 'absolute',
		fontSize: '10px',
		lineHeight: '20px',
		color: theme.palette.mode === 'dark' ? theme.palette.text.secondary : '#00000099',
		bottom: '-21px',
		right: isMyMessage ? '40px' : 'none',
		left: isMyMessage ? 'none' : '40px',
		background: theme.palette.mode === 'dark' ? theme.palette.background.paper : '#fff',
		padding: '2.5px 5px',
	}),
);
